import { loader } from "@monaco-editor/react";
import * as monaco from "monaco-editor";

// Monaco's workers are bundled offline as fixed-name same-origin assets by
// build.ts (assets/editor.worker.js + assets/json.worker.js). bun does not
// rewrite `new Worker(new URL(...))` for browser bundles, so reference the
// emitted assets by an absolute base-relative URL instead — BASE_URL is '/'
// for the committed bundle and '/dashboard/' for the hosted site build. The
// committed static/ bundle is served offline by the local `saga dashboard`.
const workerBase = `${import.meta.env.BASE_URL}assets/`;

(self as unknown as { MonacoEnvironment: monaco.Environment }).MonacoEnvironment = {
  getWorker(_workerId: string, label: string) {
    const file = label === "json" ? "json.worker.js" : "editor.worker.js";
    return new Worker(`${workerBase}${file}`, { type: "module" });
  },
};

loader.config({ monaco });
